import { Alert } from '@mui/material';

import type { MessageComponentProps } from './message-types.types';
import { StalledResponseMessage } from './stalled-response-message.component';

const isStalledError = (message: { id: string }) => message.id.endsWith('-stalled');
const isStaleError = (message: { id: string }) => message.id.endsWith('-stale');

export const ErrorMessage = ({ message, onRetry }: MessageComponentProps) => {
  if (isStaleError(message)) {
    return <Alert severity='info'>{message.content}</Alert>;
  }

  if (isStalledError(message)) {
    return <StalledResponseMessage onRetry={onRetry} />;
  }

  return <Alert severity='error'>{message.content}</Alert>;
};
